import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { OutlinedMediaLinkCard } from '../../ui-parts/OutlinedMediaLinkCard';

/** MyMine Version2.0 DigitalSolutionLv2_2画面新規追加
* DigitalSolutionLv2_2 Page Content
*/
export const DigitalSolutionLv2SubLv2 = () => {
  const screenId = 'MyM311';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/digital-solution/lv2-2', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  return (
    <Grid container className='pb-4'>
      <Grid container>
        <Grid item xs={6}>
          <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblEsgPitOptimization}</MyMVariantLabel>
          {controlSettings.LabelList.lblDescription}
        </Grid>
        <Grid item xs={6}>
        </Grid>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={8} >
        
        <Grid container>
          <Grid item xs={2}>
          </Grid>
          <Grid item xs={8}>
            <MyMLabel sx={{ textAlign: 'center' ,paddingTop:'20px'}} fontSize='28px'>{controlSettings.LabelList.lblFooter}</MyMLabel>
          </Grid>
          <Grid item xs={2}>
          </Grid>
        </Grid>
        <Grid container spacing={4} >
          <Grid item xs={3}>
            <OutlinedMediaLinkCard
              screenId={screenId}
              mediaHeight={150}
              caption={controlSettings.LabelList.lblPillarsPanelHeader1}
              descriptionHeight={300}
              description={controlSettings.LabelList.lblPillarsPanelDetail1}
              mediaImageFileName={controlSettings.ImageList.imgCaption1}
              navigateTo={`MyM312/${controlSettings.LabelList.lblPillarsPanelHeader1}`}
            />
          </Grid>
          <Grid item xs={3}>
            <OutlinedMediaLinkCard
              screenId={screenId}
              mediaHeight={150}
              caption={controlSettings.LabelList.lblPillarsPanelHeader2}
              descriptionHeight={300}
              description={controlSettings.LabelList.lblPillarsPanelDetail2}
              mediaImageFileName={controlSettings.ImageList.imgCaption2}
              navigateTo={`MyM312/${controlSettings.LabelList.lblPillarsPanelHeader2}`}
            />
          </Grid>
          <Grid item xs={3}>
            <OutlinedMediaLinkCard
              screenId={screenId}
              mediaHeight={150}
              caption={controlSettings.LabelList.lblPillarsPanelHeader3}
              descriptionHeight={300}
              description={controlSettings.LabelList.lblPillarsPanelDetail3}
              mediaImageFileName={controlSettings.ImageList.imgCaption3}
              navigateTo={`MyM312/${controlSettings.LabelList.lblPillarsPanelHeader3}`}
            />
          </Grid>
          <Grid item xs={3}>
            <OutlinedMediaLinkCard
              screenId={screenId}
              mediaHeight={150}
              caption={controlSettings.LabelList.lblPillarsPanelHeader4}
              descriptionHeight={300}
              description={controlSettings.LabelList.lblPillarsPanelDetail4}
              mediaImageFileName={controlSettings.ImageList.imgCaption4}
              navigateTo={`MyM312/${controlSettings.LabelList.lblPillarsPanelHeader4}`}
            />
          </Grid>

        </Grid >
      </Grid >
      <Grid item xs={2} />
    </Grid >
  );
}

export default DigitalSolutionLv2SubLv2;